import { useHistory } from "react-router";
import { CHANNELS_PARTNER_TYPES } from "../../libs/channels/constants/channels";

export type PageState = {
    history: ReturnType<typeof useHistory>;
    query: Record<string, string>;
    previouysPath: string;
    currentPath: string;
    genericErrorModal: {
        opened: boolean;
    };
    channels: {
        channel: string;
        partnerType: string;
        distributionCode?: string;
    };
    isStartedFlow: boolean;
};

export const pageDefaultState: PageState = {
    history: null,
    query: {},
    previouysPath: null,
    currentPath: null,
    genericErrorModal: {
        opened: false,
    },
    channels: {
        channel: null,
        partnerType: CHANNELS_PARTNER_TYPES.CUSTOMERS,
        distributionCode: null,
    },
    isStartedFlow: false,
};
